import React, { useEffect, useState } from "react";
import styles from "./ProductPage.module.css";
import { useParams } from "react-router-dom";
import { useProducts } from "../../context/ProductsContext";
import ProductBanner from "./components/ProductBanner";
import ProductPageBody from "./components/ProductPageBody";

const ProductPage = ({}) => {
  const [product, setProduct] = useState();
  const { productName } = useParams();
  const products = useProducts()[0];

  useEffect(() => {
    const productExtractor = (p) => {
      p.childs
        ? p.childs.map((e) => productExtractor(e))
        : p.list.forEach((element) => {
            element.name == productName && setProduct(element);
          });
    };
    productExtractor(products);
  }, []);

  return (
    <section className={`${styles.ProductPageCont}`}>
      <div className={`${styles.ProductPage} `}>
        <ProductBanner product={product} />
        <ProductPageBody product={product} />
      </div>
    </section>
  );
};

export default ProductPage;
